import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import All from './Pages/Blog/All';
import BlogHome from './Pages/Blog';
import EachPost from './Pages/Blog/EachPost';
import Home from './Pages/Home';
import Story from './Pages/Story';
import Store from './Pages/Store';
const MainRouter = () => {
	return (
		<div className='selection:bg-tan selection:text-slate-600'>
			<Router>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/story" element={<Story />} />
					<Route path="/blog" element={<BlogHome />} />
					{/* <Route path="/blog/featured" element={<Featured />} />
					<Route path="/blog/authors" element={<Authors />} />
					<Route path="/blog/author/:username" element={<EachAuthor />} /> */}
					<Route path="/blog/all" element={<All />} />
					<Route path="/blog/:id" element={<EachPost />} />
					<Route path="/store/" element={<Store />} />
					<Route path="*" element={<Navigate to="/" />} />
				</Routes>
			</Router>
		</div>
	)
}

export default MainRouter